import { createSlice } from '@reduxjs/toolkit';

const loadingSlice = createSlice({
  name: 'loading',
  initialState: {
    count: 0,
    message: 'Loading...'
  },
  reducers: {
    incrementLoading: (state) => {
      state.count += 1;
    },
    decrementLoading: (state) => {
      state.count = Math.max(0, state.count - 1);
    },
    setLoadingMessage: (state, action) => {
      state.message = action.payload;
    },
    resetLoading: (state) => {
      state.count = 0;
      state.message = 'Loading...';
    }
  }
});

export const { incrementLoading, decrementLoading, setLoadingMessage, resetLoading } = loadingSlice.actions;
export default loadingSlice.reducer;
